"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var pricelist_1 = require("./pricelist");
exports.PricelistService = pricelist_1.PricelistService;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/pricelists/services/index.js
// module id = 407
// module chunks = 0